import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import AppleIcon from '@/assets/icons/apple.svg?react';
import GooglePlayIcon from '@/assets/icons/google-play.svg?react';
import {
  APP_STORE_LINK,
  PLAY_STORE_LINK,
} from '@/features/download/constants/appStoreLinks';
import { Button } from '@/shared/components/ui/button';
import { WelcomeLayout } from '@/shared/components/welcomeLayout';
import { getMobilePlatform } from '@/shared/utils/mobileWeb';

export const Route = createFileRoute('/get-app')({
  component: GetApp,
});

function GetApp() {
  useEffect(() => {
    const platform = getMobilePlatform();
    if (platform === 'ios') {
      window.location.href = APP_STORE_LINK;
      return;
    }
    if (platform === 'android') {
      window.location.href = PLAY_STORE_LINK;
      return;
    }
  }, []);

  const handleAppStoreClick = () => {
    window.location.href = APP_STORE_LINK;
  };

  const handlePlayStoreClick = () => {
    window.location.href = PLAY_STORE_LINK;
  };

  return (
    <WelcomeLayout.Root>
      <WelcomeLayout.Background />
      <WelcomeLayout.Container>
        <WelcomeLayout.Logo />

        <WelcomeLayout.Content>
          <WelcomeLayout.Header />

          <WelcomeLayout.Actions>
            <Button
              variant="destructive"
              onClick={handleAppStoreClick}
              size="lg"
              className="flex-1"
            >
              <AppleIcon className="text-cold-950 size-4" />
              App Store
            </Button>
            <Button
              variant="destructive"
              onClick={handlePlayStoreClick}
              size="lg"
              className="flex-1"
            >
              <GooglePlayIcon className="text-cold-950 size-4" />
              Google Play
            </Button>
          </WelcomeLayout.Actions>

          <WelcomeLayout.Legal className="mt-12 md:mt-0" />
        </WelcomeLayout.Content>
      </WelcomeLayout.Container>
    </WelcomeLayout.Root>
  );
}
